










































































import { Component, Vue, Prop } from "vue-property-decorator";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import ConfrimDialog from "@/components/dialogs/confirmDialog.vue";
import LeftNav from "../../components/left-nav.vue";
import axios, { resHandle } from "../../../../plugins/axios";
@Component({
  components: {
    Pagination,
    MainHeader,
    ConfrimDialog,
    LeftNav
  }
})
export default class DigMyReport extends Vue {
  // 搜索
  private filters: any = {};
  private types: any[] = [
    "舌象特征",
    "面象特征",
    "脉象特征",
    "临床疗效",
    "专家辨证经验",
    "专家用药经验"
  ];
  private projects: any[] = [];
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 数据
  private reports: any[] = [];
  // 确认弹窗
  private cReport: any = {};
  private ifShowConfirmDialog: boolean = false;
  private confirmTitle: string = "温馨提示";
  private confirmHelp: string = "确定要删除这份报告吗？";
  /**
   * @description 获取项目列表
   */
  private fetchProjects() {
    axios.get("api/wajue/projects").then(({ data }) => {
      resHandle(this, data).then(() => {
        this.projects = data.data;
      });
    });
  }
  /**
   * @description 获取报告
   */
  private fetchReports() {
    const params: any = {
      params: {
        分类: this.filters["分类"],
        project_id: this.filters.project_id,
        search: this.filters.search,
        current_page: this.currentPage,
        page_count: this.pageSize
      }
    };
    axios.get("api/wajue/reports", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.reports = data.data.reports;
        this.totalPage = data.data.total_page;
        this.totalCount = data.data.total_count;
        console.log(this.reports);
      });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchReports();
  }
  /**
   * @description 跳转报告详情
   */
  private goToReport(report) {
    this.$router.push("/main/dig/report-detail/" + report.report_id);
  }
  /**
   * @description 导出报告
   */
  private exportReport(report) {
    console.log(report);
  }
  /**
   * @description 打开删除弹窗
   */
  private openDeleteReportConfirm(report) {
    this.cReport = report;
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "确定要删除这份报告吗？";
    this.ifShowConfirmDialog = true;
  }
  /**
   * @description 删除报告
   */
  private deleteReport() {
    const params: any = {
      data: {
        report_id: this.cReport.report_id
      }
    };
    axios.delete("api/wajue/report", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功！");
        this.fetchReports();
        this.ifShowConfirmDialog = false;
      });
    });
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchReports();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchProjects();
    this.fetchReports();
  }
}
